import styled from 'styled-components';


export const NonprofitSuccessStoriesSection = styled.section`
    width: 100%;

    @media screen and (max-width: 1024px){ 
        padding-top: 30px;
    }

    .row {
        align-items: center;
    }
    .search-header{
        display:none;
    }
    p {
        padding-bottom: 25px;
        &:last-child{
            padding-bottom: 0px;
        }
    }

    .left_banner{
        margin-bottom: 0px;
    }
`;

export const FeaturedSuccessStoriesSection = styled.section`
    width: 100%;
    background: #F1FEFF;
    padding: 50px 0px;

    @media screen and (max-width: 575px){
        padding: 40px 0px;
    }
`;

export const FeaturedSuccessStoriesWrap = styled.section`
    width: 100%;
    background: #FFFFFF;
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 991px){ 
        padding: 20px;
    }
`;

export const FeaturedSuccessStoriesTitle = styled.h2`
    width: 100%;
    color: #555555;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 20px;
    
    @media screen and (max-width: 991px){ 
        font-size: 28px;
        line-height: 40px;
    }
    @media screen and (max-width: 575px){ 
        font-size: 26px;
        line-height: 38px;
    }
`;


export const FeaturedStoriesWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;
`;

export const FeaturedStoriesBox = styled.div`
    width: 100%;
    background: #F3F3F3;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 20px;
    padding: 20px;
    border-radius: 15px;
    
    @media screen and (max-width: 575px){
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        row-gap: 20px;
    }
`;

export const FeaturedStoriesImage = styled.div`
    max-width: 250px;
    width: 100%;
    border-radius: 15px;
    overflow: hidden;

    @media screen and (max-width: 575px){
        max-width: 100%;
    }

    img{
        display:  block;
        width: 100%;
        height: 100%;
    }
`;

export const FeaturedStoriesContent = styled.div`
    color: #555555;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 22px;
`;

export const FeaturedStoriesSubTitle = styled.h3`
    color: #01606F;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 2px;
`;

export const FeaturedStoriesSubText = styled.p`
    padding-bottom: 15px;
    margin: 0px;
    &:last-child{
        padding-bottom: 0px;
    }
`;